import script from "./sw-item-editor-url.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-editor-url.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-editor-url.vue?vue&type=style&index=0&id=bc865d2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc865d2e"]])

export default __exports__